'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { useReCaptcha } from 'next-recaptcha-v3';
import { useHelpWidget } from '../HelpWidgetContext';
import submitSalesAssistanceAction from '@/app/_lib/actions/SubmitSalesAssistanceAction';
const HelpSalesAssistance = () => {
  const {
    setPanel
  } = useHelpWidget();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(null);
  const {
    executeRecaptcha
  } = useReCaptcha();
  const handleSubmit = async formData => {
    setIsPending(true);
    setError(null);
    try {
      const token = await executeRecaptcha('sales_assistance');
      formData.set('recaptcha_token', token);
      const response = await submitSalesAssistanceAction(formData);
      if (response.success) {
        setIsSubmitted(true);
      } else {
        setError(response.message || 'An error occurred. Please try again.');
      }
    } catch (err) {
      setError('An error occurred. Please try again.');
    } finally {
      setIsPending(false);
    }
  };
  if (isSubmitted) {
    return <div className="p-4">
                <h3 className="text-md font-semibold mb-3">Thank you.</h3>
                <p className="text-sm mb-4">
                    We have received your message and will be in touch shortly.
                </p>
                <button onClick={() => setPanel('main')} className="text-sm text-primary hover:underline">
                    return to help menu
                </button>
                <ContactInfo />
            </div>;
  }
  return <div className="p-4">
            <h3 className="text-md font-semibold mb-2">Sales Assistance</h3>
            <p className="text-sm text-light mb-4">
                Some questions are best answered in conversation. Whether you're exploring a product, planning a project, or simply need guidance, our team is ready to help. Call us toll free at{' '}
                <a href="tel:+18666634483" className="text-primary hover:underline">866 663 4483</a>{' '}
                or complete the form below and we'll be in touch shortly.
            </p>

            <form action={handleSubmit}>
                {error && <div className="text-red text-sm mb-3">{error}</div>}

                <div className="form-group mb-3">
                    <input type="text" name="name" autoComplete="name" className="form-input form-input-sm peer" placeholder=" " required disabled={isPending} />
                    <label className="form-input-label form-input-label-sm peer-placeholder-shown:form-input-label-placeholder-shown">
                        your full name <span className="text-primary">*</span>
                    </label>
                </div>

                <div className="form-group mb-3">
                    <input type="email" name="email" autoComplete="email" className="form-input form-input-sm peer" placeholder=" " required disabled={isPending} />
                    <label className="form-input-label form-input-label-sm peer-placeholder-shown:form-input-label-placeholder-shown">
                        email <span className="text-primary">*</span>
                    </label>
                </div>

                <div className="form-group mb-3">
                    <input type="tel" name="phone" autoComplete="tel" inputMode="tel" className="form-input form-input-sm peer" placeholder=" " disabled={isPending} />
                    <label className="form-input-label form-input-label-sm peer-placeholder-shown:form-input-label-placeholder-shown">
                        phone
                    </label>
                </div>

                <div className="form-group mb-3">
                    <input type="text" name="product" className="form-input form-input-sm peer" placeholder=" " disabled={isPending} />
                    <label className="form-input-label form-input-label-sm peer-placeholder-shown:form-input-label-placeholder-shown">
                        What product are you interested in?
                    </label>
                </div>

                <div className="form-group mb-4">
                    <textarea name="message" className="form-input form-input-sm peer" placeholder=" " rows="3" required disabled={isPending} />
                    <label className="form-input-label form-input-label-sm peer-placeholder-shown:form-input-label-placeholder-shown">
                        additional information <span className="text-primary">*</span>
                    </label>
                </div>

                <button type="submit" disabled={isPending} className={`btn btn-primary btn-sm w-full ${isPending ? 'opacity-50' : ''}`}>
                    {isPending ? 'submitting...' : 'submit request'}
                </button>
            </form>
        </div>;
};
const ContactInfo = () => {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-primary font-medium">hive</div>;
    t1 = <div>820 nw glisan street</div>;
    t2 = <div>portland or 97209</div>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div>tele: <a href="tel:+15032421967" className="hover:text-primary">503.242.1967</a></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div>fax: <a href="tel:+15032425573" className="hover:text-primary">503.242.5573</a></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="text-sm text-light mt-4 pt-4 border-t border-gray-10">{t0}{t1}{t2}{t3}{t4}<div>toll-free: <a href="tel:+18666634483" className="hover:text-primary">1.866.663.4483</a></div><div><a href="mailto:info@hivemodern.com" className="text-primary hover:underline">info@hivemodern.com</a></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default HelpSalesAssistance;